// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "ebf3582fc1f760b6569f87048dee3c9ce98551c2/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"41":"a0ec33ed","440":"486bdddc","581":"a474c96c","788":"8f99306d","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};